import React, { Fragment } from "react"
import { ToggleOption } from "bootstrap-micro"
import { Row } from "../../DataTable.jsx"
import { MULTILOOP_RS232_BAUD_RATE } from "../../const.js";
import { useMemo } from "react";


const useBitmask = (value, fields) => {
    return useMemo(
        () => Object.fromEntries(fields.map( (f, i) => [f, (((value >> i) & 1) > 0 )] )),
        [value, fields]
    )
}


const FIELDS = ["alarms", "fault", "tech_alarm", "buttons"];


export const RS232Module = ({ module }) => {

    const bitmask = useBitmask(module.settings.printerOptions, FIELDS);

    return <Fragment>
        <Row label="Address">
            <select className="form-control" value={module.settings.serialConfig.bitRate}>
                {
                    Object.entries(MULTILOOP_RS232_BAUD_RATE)
                        .map( ([k, v]) => <option value={k} key={k}>{v}</option>)
                }
            </select>
        </Row>
        <Row label="Alarms" noParagraph>
            <ToggleOption value={bitmask.alarms} />
        </Row>
        <Row label="Faults" noParagraph> <ToggleOption value={bitmask.fault}/> </Row>
        <Row label="Tech. Alarms" noParagraph> <ToggleOption value={bitmask.tech_alarm}/> </Row>
        <Row label="Buttons" noParagraph> <ToggleOption value={bitmask.buttons}/> </Row>
    </Fragment>
}